import Extractor from './extractor.js';

class InfoCard extends Extractor{

  extract(item){
    const result = super.extract(item);
    const data = item.pagemap;

    var nameTitle = 'Name';
    var orgTitle = 'Name';
    if(item.type === 'imdb'){
      nameTitle = 'Cast';
      orgTitle = 'Producer';
    }

    this.append(result, 'title', 'Name',
      [
        {instance: data, object:'metatags', property: 'og:title'},        
        {instance: data, object:'metatags', property: 'og:site_name'},        
        {instance: data, object:'blogposting', property: 'headline'},        
      ], null);

    this.append(result, 'type', 'Type',
      [
        {instance: data, object:'metatags', property: 'og:type'},        
      ], null);

    this.append(result, 'person_name', nameTitle,
      [
        {instance: data, object:'person', property: 'name'},        
      ], null);

    this.append(result, 'twitter', 'Twitter',
      [
        {instance: data, object:'metatags', property: 'twitter:site'},
      ], null);


    if(item.displayLink.includes('instagram.com')){
      //const instagram = item.title.split('(')[1].split(')')[0];
      //result['instagram'] = {title: "Instagram", value: instagram};
    }

    this.append(result, 'address_street', 'Street',
      [
        {instance: data, object:'postaladdress', property: 'streetaddress'},        
      ], null);

    this.append(result, 'address_locality', 'Locality',
      [
        {instance: data, object:'postaladdress', property: 'addresslocality'},        
      ], null);

    this.append(result, 'address_region', 'Region',
      [
        {instance: data, object:'postaladdress', property: 'addressregion'},        
      ], null);


    this.append(result, 'address_code', 'Code',
      [
        {instance: data, object:'postaladdress', property: 'postalcode'},        
      ], null);

    this.append(result, 'address_country', 'Country',
      [
        {instance: data, object:'postaladdress', property: 'addresscountry'},        
      ], null);


    this.append(result, 'organization_name', orgTitle,
      [
        {instance: data, object:'organization', property: 'name'},        
      ], null);

    this.append(result, 'organization_department', 'Department',
      [
        {instance: data, object:'organization', property: 'department'},        
      ], null);

    this.append(result, 'organization_country', 'Country',
      [
        {instance: data, object:'organization', property: 'country'},        
      ], null);

    this.append(result, 'organization_city', 'City',
      [
        {instance: data, object:'organization', property: 'city'},        
      ], null);

    this.append(result, 'business_name', 'Name',
      [
        {instance: data, object:'localbusiness', property: 'name'},        
      ], null);

    this.append(result, 'business_telephone', 'Telephone',
      [
        {instance: data, object:'localbusiness', property: 'telephone'},        
      ], null);

    this.append(result, 'business_price', 'Price',
      [
        {instance: data, object:'localbusiness', property: 'pricerange'},        
      ], null);

    this.append(result, 'tvseries_name', 'Name',
      [
        {instance: data, object:'tvseries', property: 'name'},        
      ], null);

    this.append(result, 'tvseries_rating', 'Rating',
      [
        {instance: data, object:'tvseries', property: 'contentrating'},        
      ], null);

    this.append(result, 'tvseries_duration', 'Duration',
      [
        {instance: data, object:'tvseries', property: 'duration'},        
      ], null);

    this.append(result, 'tvseries_genre', 'Genre',
      [
        {instance: data, object:'tvseries', property: 'genre'},        
      ], null);

    this.append(result, 'tvseries_trailer', 'Trailer',
      [
        {instance: data, object:'tvseries', property: 'trailer'},        
      ], null);

    this.append(result, 'tvseries_headline', 'Headline',
      [
        {instance: data, object:'tvseries', property: 'headline'},        
      ], null);

    this.append(result, 'tvseries_description', 'Description',
      [
        {instance: data, object:'tvseries', property: 'description'},        
      ], null);

    this.append(result, 'tvseries_published', 'Published',
      [
        {instance: data, object:'tvseries', property: 'datepublished'},        
      ], null);

    this.append(result, 'tvseries_provider', 'Provider',
      [
        {instance: data, object:'tvseries', property: 'provider'},        
      ], null);

    this.append(result, 'tvseries_awards', 'Awards',
      [
        {instance: data, object:'tvseries', property: 'awards'},        
      ], null);

    this.append(result, 'tvseries_keywords', 'Keywords',
      [
        {instance: data, object:'tvseries', property: 'keywords'},        
      ], null);

    this.append(result, 'tvseries_episode_name', 'Episode',
      [
        {instance: data, object:'episode', property: 'name'},        
      ], null);

    this.append(result, 'tvseries_episode_number', 'Number',
      [
        {instance: data, object:'episode', property: 'episodenumber'},        
      ], null);

    this.append(result, 'tvseries_audience', 'Audience',
      [
        {instance: data, object:'audience', property: 'url'},        
      ], null);

    this.append(result, 'keywords', 'Keywords',
      [
        {instance: data, object:'metatags', property: 'shareaholic:keywords'},
        {instance: data, object:'videoobject', property: 'keywords'},
      ], null);

    this.append(result, 'author', 'Author',
      [
        {instance: data, object:'metatags', property: 'author'},        
      ], null);

    result['has_data'] = (result['author'] || result['keywords'] || result['type'] || result['title'] || result['twitter'] || result['instagram'] || result['tvseries_name'] || result['business_name'] || result['organization_name'] || result['person_name'] || result['address_street']) ? 1 : 0;
 
    return result;
  }
}

export default (InfoCard);


// WEBPACK FOOTER //
// ./src/search/extractor/infocard.js